import * as React from "react";
import { IssueRow } from "./IssueRow";
import type { CategoryId } from "./tokens";
import type { RowWithIndex } from "./types";
import { getRowReviewStatus } from "./utils";
import type { RowReviewStatus } from "./utils";

export type IssueListProps = {
  items: RowWithIndex[];
  category: CategoryId;
  selectedKey: string | null;
  focusedKey: string | null;
  aiRowStatus: Record<string, RowReviewStatus>;
  onOpenIssue: (item: RowWithIndex, category: CategoryId) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
};

export const IssueList: React.FC<IssueListProps> = ({
  items,
  category,
  selectedKey,
  focusedKey,
  aiRowStatus,
  onOpenIssue,
  onKeyDown,
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className="ai-analysis__issue-list"
      onKeyDown={onKeyDown}
      tabIndex={0}
      role="list"
    >
      {items.map((item) => (
        <IssueRow
          key={item.key}
          item={item}
          status={getRowReviewStatus(item.row, item.key, aiRowStatus)}
          selected={selectedKey === item.key}
          focused={focusedKey === item.key}
          onClick={() => onOpenIssue(item, category)}
        />
      ))}
    </div>
  );
};
